import { UseFormReturn } from 'react-hook-form';
import { useCoordinatedForm } from './useCoordinatedForm';

export interface IFormCoordinatorRegisterProps {
  id?: string | null;
  methods: UseFormReturn;
}

/**
 * Registra il form all'interno del FormCoordinator.
 * Utilizziamo un componente dedicato per evitare il re-render del tree
 * sottostante.
 */
export function FormCoordinatorRegister(props: IFormCoordinatorRegisterProps) {
  useCoordinatedForm({
    id: props.id,
    methods: props.methods,
  });

  return null;
}
